import { render, staticRenderFns } from "./FormPart5.vue?vue&type=template&id=087f79e2&scoped=true"
import script from "./FormPart5.vue?vue&type=script&lang=js"
export * from "./FormPart5.vue?vue&type=script&lang=js"
import style0 from "./FormPart5.vue?vue&type=style&index=0&id=087f79e2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "087f79e2",
  null
  
)

export default component.exports